var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.07 9.375L12.17 10.295C11.45 11.015 11 11.625 11 13.125H9V12.625C9 11.515 9.45 10.515 10.17 9.795L11.41 8.535C11.78 8.175 12 7.675 12 7.125C12 6.59457 11.7893 6.08586 11.4142 5.71079C11.0391 5.33571 10.5304 5.125 10 5.125C9.46957 5.125 8.96086 5.33571 8.58579 5.71079C8.21071 6.08586 8 6.59457 8 7.125H6C6 6.06413 6.42143 5.04672 7.17157 4.29657C7.92172 3.54643 8.93913 3.125 10 3.125C11.0609 3.125 12.0783 3.54643 12.8284 4.29657C13.5786 5.04672 14 6.06413 14 7.125C13.9986 7.96824 13.6643 8.77683 13.07 9.375V9.375ZM11 17.125H9V15.125H11V17.125ZM10 0.125C8.68678 0.125 7.38642 0.383658 6.17317 0.886205C4.95991 1.38875 3.85752 2.12535 2.92893 3.05393C1.05357 4.9293 0 7.47284 0 10.125C0 12.7772 1.05357 15.3207 2.92893 17.1961C3.85752 18.1247 4.95991 18.8612 6.17317 19.3638C7.38642 19.8663 8.68678 20.125 10 20.125C12.6522 20.125 15.1957 19.0714 17.0711 17.1961C18.9464 15.3207 20 12.7772 20 10.125C20 4.595 15.5 0.125 10 0.125Z",
    fill: "#557B97"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.b7736a61872433b79b1899b143391e95.svg";
export { ForwardRef as ReactComponent };